import { Observable } from 'rxjs';
import { Injectable} from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { IHttpRequestOptions, IResponse, IResponseLower } from '../interfaces/response.interface';

@Injectable({
    providedIn: 'root'
})
export class HttpService {

    // tslint:disable-next-line:max-line-length
    constructor(private http$: HttpClient) {

    }

    get<T>(url: string, httpParams?: HttpParams, options?: IHttpRequestOptions): Observable<IResponse<T>> {
        httpParams = this.getParams(options, httpParams);
        return this.http$.get<IResponse<T>>(url, { params: httpParams });
    }

    getLower<T>(url: string, httpParams?: HttpParams, options?: IHttpRequestOptions): Observable<IResponseLower<T>> {
        httpParams = this.getParams(options, httpParams);
        return this.http$.get<IResponseLower<T>>(url, { params: httpParams });
    }

    post<T>(url: string, body: any, options?: IHttpRequestOptions): Observable<IResponse<T>> {
        const params = this.getParams(options);
        return this.http$.post<IResponse<T>>(url, body, { params });
    }

    postLower<T>(url: string, body: any, options?: IHttpRequestOptions): Observable<IResponseLower<T>> {
        const params = this.getParams(options);
        return this.http$.post<IResponseLower<T>>(url, body, { params });
    }

    put<T>(url: string, body: any, options?: IHttpRequestOptions): Observable<IResponse<T>> {
        const params = this.getParams(options);
        return this.http$.post<IResponse<T>>(url, body, { params });
    }

    delete<T>(url: string, options?: IHttpRequestOptions): Observable<IResponse<T>> {
        const params = this.getParams(options);
        return this.http$.delete<IResponse<T>>(url, { params });
    }

    multipart<T>(url: string, formData: FormData, httpParams?: HttpParams, options?: IHttpRequestOptions): Observable<IResponse<T>> {
        httpParams = this.getParams(options, httpParams);
        return this.http$.post<IResponse<T>>(url, formData, { params: httpParams });
    }

    /**
    * @deprecated Since moveing to new node/nestjs.
    */

    getWithSsrCache<T>(url: string, cacheKey: string, httpParams?: HttpParams, options?: IHttpRequestOptions): Observable<IResponse<T>> {
        httpParams = this.getParams(options, httpParams);
        return this.get<T>(url, httpParams);
    }

    /**
    * @deprecated Since moveing to new node/nestjs.
    */
    getLowerWithSsrCache<T>(url: string, cacheKey: string, httpParams?: HttpParams, options?: IHttpRequestOptions): Observable<IResponseLower<T>> {
        httpParams = this.getParams(options, httpParams);
        return this.getLower<T>(url, httpParams);
    }

    private getParams(options: IHttpRequestOptions, httpParams?: HttpParams): HttpParams {
        if (options && options.useToken) {
            if (httpParams && httpParams.append) {
                return httpParams.append('interceptorUseToken', 'use');
            } else {
                if (options && options.tokenGroup) {
                    return new HttpParams().append('interceptorUseToken', 'use').append('tokenGroup', options.tokenGroup as string);
                } else {
                    return new HttpParams().append('interceptorUseToken', 'use');
                }
            }
        }
        if (options && options.tokenGroup) {
            if (httpParams && httpParams.append) {
                return httpParams.append('tokenGroup', options.tokenGroup as string);
            } else {
                return new HttpParams().append('tokenGroup', options.tokenGroup as string);
            }
        }
        return httpParams || null;
    }

}
